export const marketingContact = [
  //Bouncer Error
  {
    internal_code: 1001,
    message: 'Unexpected error with Bouncer. The contact is not added.',
    toast: true,
  },

  //INVALID_EMPLOYER  INVALID_MM_EMPLOYER_ERROR = 2001;
  {
    internal_code: 2001,
    message: 'The contact could not be stored due to an unexpected error.',
    toast: true,
  },

  //CONTACT_ADDED_SUCCESSFULLY_TO_HUBSPOT = 3001;
  {
    internal_code: 3001,
    message: 'The contact was successfully added to HubSpot.',
    toast: true,
  },

  //ADDED_CONTACT_EXISTS_IN_HUBSPOT = 3002;
  {
    internal_code: 3002,
    message: 'The contact was added, but it already exists in HubSpot.',
    toast: true,
  },

  //EXISTING_MM_CONTACT_ERROR = 3003;
  {
    internal_code: 3003,
    message: 'The contact could not be added as it already exists in Jobshark.',
    toast: true,
  },

  //EXISTING_MM_CONTACT_ERROR = 3004;
  {
    internal_code: 3004,
    message: 'Unexpected error. Could not add the contact to Jobshark.',
    toast: true,
  },

  //CONTACT_NOT_ADDED_TO_HUBSPOT_DUE_TO_LOW_SCORE_ERROR = 3005;
  {
    internal_code: 3005,
    message: '',
    toast: false, // False Shows the Modal with scores from BE
  },

  //HUBSPOT
  {
    internal_code: 4001,
    message: 'Unexpected error with HubSpot. The contact is not added.',
    toast: true,
  },

  {
    internal_code: 4002,
    message: 'The contact was added, but it already exists in HubSpot.',
    toast: true,
  },

  {
    internal_code: 3007,
    message: 'Email permutation initiated and queued.',
    toast: true,
  },
];
